/**
 * Parcely — hide the locker option when the cart contains "Dideli gabaritai" items,
 * and show live prices next to each option.
 *
 * Detection is rate-based: Shopify drops the locker rate from mixed carts because
 * "Omniva paštomatas" exists only in the General profile. If the rate is absent,
 * the cart is oversized by definition. No product flags needed.
 */
(function () {
  'use strict';

  const CFG = {
    country: 'Lithuania',
    zip: '01100',

    // Row identification — matched against the row's visible text
    lockerWords:  ['locker', 'pick-up', 'pastomat'],
    courierWords: ['kurjeris', 'courier'],

    // Shopify rate names (diacritics are stripped before matching)
    lockerRateName:  'pastomatas',   // "Omniva paštomatas"
    courierRateName: 'kurjeris',     // "Kurjeris"

    showPrices: true,
    freeLabel: 'Nemokamai',
    debug: true
  };

  let lastSignature = null;
  let busy = false;

  const log = (...a) => CFG.debug && console.log('[parcely]', ...a);

  const norm = s => (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const hasWord = (el, words) =>
    words.some(w => norm(el.textContent).includes(norm(w)));

  const money = p => {
    const n = parseFloat(p);
    if (isNaN(n)) return '';
    return n === 0 ? CFG.freeLabel : n.toFixed(2).replace('.', ',') + ' €';
  };

  /* Tag rows by role so CSS can target them regardless of order */
  function tagRows() {
    const nodes = document.querySelectorAll('.parcely_app_shipping_method');
    if (!nodes.length) return null;
    let locker = null, courier = null;
    nodes.forEach(row => {
      if (hasWord(row, CFG.lockerWords))  { row.classList.add('is-locker');  locker = row; }
      if (hasWord(row, CFG.courierWords)) { row.classList.add('is-courier'); courier = row; }
    });
    return { locker, courier, all: nodes };
  }

  function getRates() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const qs = 'shipping_address%5Bcountry%5D=' + encodeURIComponent(CFG.country) +
               '&shipping_address%5Bprovince%5D=' +
               '&shipping_address%5Bzip%5D=' + encodeURIComponent(CFG.zip);
    return fetch(root + 'cart/shipping_rates.json?' + qs, { headers: { Accept: 'application/json' } })
      .then(r => (r.ok ? r.json() : { shipping_rates: [] }))
      .then(d => d.shipping_rates || [])
      .catch(() => []);
  }

  function splitRates(rates) {
    return {
      locker:  rates.find(r => norm(r.name).includes(CFG.lockerRateName))  || null,
      courier: rates.find(r => norm(r.name).includes(CFG.courierRateName)) || null
    };
  }

  function renderPrices(rows, rates) {
    if (!CFG.showPrices) return;
    const put = (row, rate) => {
      if (!row) return;
      let tag = row.querySelector('.parcely-price');
      if (!rate) { if (tag) tag.remove(); return; }
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'parcely-price';
        row.appendChild(tag);
      }
      tag.textContent = money(rate.price);
    };
    put(rows.locker, rates.locker);
    put(rows.courier, rates.courier);
  }

  function selectCourier(rows) {
    if (!rows.courier) return;
    const radio = rows.courier.querySelector('.parcelyRadio');
    if (radio && radio.checked) return;
    if (rows.courier.classList.contains('selected')) return;
    rows.courier.click();                       // Parcely binds to the row
    setTimeout(() => {                          // fallback: the input itself
      const r = rows.courier.querySelector('.parcelyRadio');
      if (r && !r.checked) r.click();
    }, 150);
  }

  function run() {
    if (busy) return;
    busy = true;

    getRates().then(rawRates => {
      busy = false;
      const rows = tagRows();
      if (!rows) return;

      const rates = splitRates(rawRates);
      const courierOnly = rawRates.length > 0 && !rates.locker;

      renderPrices(rows, rates);
      document.body.classList.add('parcely-ready');

      const sig = [courierOnly,
                   rates.locker && rates.locker.price,
                   rates.courier && rates.courier.price].join('|');
      if (sig === lastSignature) return;
      lastSignature = sig;
      log('courierOnly:', courierOnly, '| rates:', rawRates.map(r => r.name));

      document.body.classList.toggle('parcely-hide-locker', courierOnly);
      if (courierOnly) selectCourier(rows);
    }).catch(() => { busy = false; });
  }

  const refresh = () => { lastSignature = null; setTimeout(run, 250); };

  /* Widget mounts asynchronously */
  let seen = false;
  new MutationObserver(() => {
    const present = !!document.querySelector('.parcely_app_shipping_method');
    if (present && !seen) { seen = true; run(); }
    if (!present) seen = false;
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Cart mutations — fetch */
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    return origFetch.apply(this, args).then(res => {
      const url = (args[0] && args[0].url) || String(args[0]);
      if (/\/cart\/(add|change|update|clear)/.test(url)) refresh();
      return res;
    });
  };

  /* Cart mutations — XHR */
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.addEventListener('load', function () {
      if (/\/cart\/(add|change|update|clear)/.test(String(url))) refresh();
    });
    return origOpen.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(e =>
    document.addEventListener(e, refresh)
  );

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('pageshow', refresh);
  run();
})();